import { OneSignalRetryBanner } from "@/components/notifications/OneSignalRetryBanner";
import type { OneSignalErrorType } from "@/contexts/OneSignalContext";

export interface HomeBannersProps {
    isAuthenticated: boolean;
    oneSignalError: OneSignalErrorType | null;
    isOneSignalRetrying: boolean;
    onRetryOneSignal: () => void;
    onDismissOneSignal: () => void;
    notificationPermission?: NotificationPermission | null;
}

/**
 * HomeBanners - Wrapper component for all home page banners.
 * Shows signup banner for unauthenticated users.
 */
const HomeBanners = ({
    isAuthenticated,
    oneSignalError,
    isOneSignalRetrying,
    onRetryOneSignal,
    onDismissOneSignal,
    notificationPermission,
}: HomeBannersProps) => {
    return (
        <>
            {/* OneSignal banner - shows for errors OR when notifications not enabled, hidden when granted */}
            {isAuthenticated && notificationPermission !== "granted" && (
                <OneSignalRetryBanner
                    errorMessage={oneSignalError?.message}
                    onRetry={onRetryOneSignal}
                    onDismiss={onDismissOneSignal}
                    isRetrying={isOneSignalRetrying}
                />
            )}
        </>
    );
};

export default HomeBanners;
